import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, isRef as _isRef, normalizeClass as _normalizeClass, createVNode as _createVNode, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createSlots as _createSlots, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import InputField from './InputField.vue';
import { SearchItem } from '@/typings/dropdown';
import { useVModels } from '@vueuse/core';

interface Props {
  modelValue: unknown;
  title?: string;
  hint?: string;
  disabled?: boolean;
  validationError?: string;
  placeholder?: string;
  items: SearchItem[];
  status?: string;
}


export default /*#__PURE__*/_defineComponent({
  props: {
    modelValue: null,
    title: null,
    hint: null,
    disabled: { type: Boolean },
    validationError: null,
    placeholder: null,
    items: null,
    status: null
  },
  setup(__props: any) {

const props = __props as {
  modelValue: unknown;
  title?: string;
  hint?: string;
  disabled?: boolean;
  validationError?: string;
  placeholder?: string;
  items: SearchItem[];
  status?: string;
}



const { modelValue: model } = useVModels(props);

const reducer = (item: SearchItem) => item.value;

return (_ctx: any,_cache: any) => {
  const _component_v_select = _resolveComponent("v-select")!

  return (_openBlock(), _createBlock(InputField, {
    title: __props.title,
    "validation-error": __props.validationError,
    hint: __props.hint
  }, _createSlots({
    status: _withCtx(() => [
      _createTextVNode(_toDisplayString(__props.status), 1)
    ]),
    default: _withCtx(() => [
      _createVNode(_component_v_select, {
        options: __props.items,
        modelValue: _unref(model),
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(model) ? (model).value = $event : null)),
        label: "text",
        reduce: reducer,
        disabled: __props.disabled,
        class: _normalizeClass([
        'border-b',
        {
          'border-red-500 text-red-500': __props.validationError,
          'border-input-decoration': !__props.validationError,
        },
      ])
      }, null, 8, ["options", "modelValue", "disabled", "class"])
    ]),
    _: 2
  }, [
    (_ctx.$slots['notes'])
      ? {
          name: "notes",
          fn: _withCtx(() => [
            _renderSlot(_ctx.$slots, "notes")
          ])
        }
      : undefined,
    (_ctx.$slots['badge'])
      ? {
          name: "badge",
          fn: _withCtx(() => [
            _renderSlot(_ctx.$slots, "badge")
          ])
        }
      : undefined
  ]), 1032, ["title", "validation-error", "hint"]))
}
}

})